import(/* webpackMode: "eager" */ "/home/ubuntu/download/698e613ff782d500148d0ff0/sdsa_website/src/app/about/page.tsx");
